import { FC, PropsWithChildren, useEffect, useRef } from 'react';
import { useImpression } from '../../hooks/useImpression';

export interface ObservableWidgetContainerProps extends PropsWithChildren {
  handleWidgetImpression: () => void;
  triggerOnce?: boolean;
  rootMargin?: string;
  threshold?: number;
}

export const ObservableWidgetContainer: FC<ObservableWidgetContainerProps> = ({
  handleWidgetImpression,
  triggerOnce,
  rootMargin,
  threshold,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const isWidgetVisible = useImpression(ref, {
    triggerOnce,
    rootMargin,
    threshold,
  });

  useEffect(() => {
    if (isWidgetVisible && handleWidgetImpression) {
      handleWidgetImpression();
    }
  }, [isWidgetVisible]);

  return (
    <div ref={ref} className={'oservable-widget-container'}>
      {children}
    </div>
  );
};
